const { IP_PUBLIC } = Config;

import React from "react";
import { useTranslation } from "react-i18next";
import * as API from "../../lib/api";

export default function DNSCheck(props) {
    const { t } = useTranslation();

    const [upd, setUpd] = React.useState(Date.now());
    const [status, setStatus] = React.useState("load");
    const [statusText, setStatusText] = React.useState("load");

    React.useEffect(() => {
        if (!props.domain) {
            return;
        }

        check(props.domain);

        const timeout = setTimeout(() => {
            setUpd(Date.now());
        }, 30000);

        return () => {
            clearTimeout(timeout);
        };
    }, [props.domain, upd]);

    function check(domain) {
        setStatus("load");
        return API.DNSCheck(domain)
            .then(res => new Promise(resolve => setTimeout(() => resolve(res), 2000)))
            .then(res => {
                if (res.ok) {
                    setStatus("ok");
                    setStatusText("ok");
                    props.onOk && props.onOk();
                } else {
                    setStatus("nok");
                    setStatusText("nok");
                    props.onNotOk && props.onNotOk();
                }

                return res.ok;
            })
            .catch(err => {
                console.warn(err.message);
                setStatus("load");
            });
    }

    return (
        <div className="panel-dns-check">
            <img className={status !== "ok" ? "hide" : null} src="/img/icon-accept.svg" />
            <img className={status !== "nok" ? "hide" : null} src="/img/icon-decline.svg" />
            <img className={status !== "load" ? "hide" : null} src="/img/icon-loading.svg" />

            {statusText === "ok" && (
                <span>
                    {t("WebsiteSettingsDNSIsConfigured")
                        .replace(/%DOMAIN%/g, props.domain)
                        .replace(/%IP_PUBLIC%/g, IP_PUBLIC)}
                </span>
            )}

            {statusText === "nok" && (
                <span>
                    {t("WebsiteSettingsDNSIsNotConfigured")
                        .replace(/%DOMAIN%/g, props.domain)
                        .replace(/%IP_PUBLIC%/g, IP_PUBLIC)}
                </span>
            )}

            {statusText === "load" && <span>{t("Loading")}...</span>}
        </div>
    );
}
